import { CaseV1, type CaseV1Data } from "@dd/schema";
import bellamiraRaw from "../../../../content/cases/f0-bellamira.json";
import cardalRaw from "../../../../content/cases/f0-cardal.json";

/**
 * Registro de casos (F0→F1). Los casos viven en content/cases como datos puros
 * (validados también por `pnpm validate:case`); acá solo se parsean al cargar —
 * si el JSON y el schema divergen, revienta en dev, no en manos de un
 * playtester. El loader real por catálogo (C16/C23) llega con el pipeline F2.
 *
 * Selección: `?exp=<id>` en la URL o el selector del login. El save de cada
 * caso es independiente (autosave por caseId, F0-T15).
 */

const parse = (raw: unknown): CaseV1Data => CaseV1.parse(raw);

export const CASE_REGISTRY: readonly CaseV1Data[] = [parse(bellamiraRaw), parse(cardalRaw)];

export const DEFAULT_CASE_ID = "f0-bellamira";

export function resolveCase(id: string | null | undefined): CaseV1Data {
  const found = CASE_REGISTRY.find((k) => k.id === id);
  if (found) return found;
  const fallback = CASE_REGISTRY.find((k) => k.id === DEFAULT_CASE_ID);
  if (!fallback) throw new Error("Registro de casos vacío");
  return fallback;
}

/** Id de caso pedido por URL (`?exp=f0-cardal`), si existe en el registro */
export function caseIdFromUrl(): string | null {
  const id = new URLSearchParams(window.location.search).get("exp");
  return CASE_REGISTRY.some((k) => k.id === id) ? id : null;
}
